module.exports = __webpack_public_path__ + "d308073b/img/revit-icon.5ff0d581.svg";